import styled from "styled-components";

export const ContentChart = styled.div`
  min-width: 400px;

  background: ${({ theme }) => theme.colors.background.white};
  padding: 20px 10px 0;

  border-radius: 16px;
  box-shadow: rgba(0, 0, 0, 0.14) 0px 1px 1px, rgba(0, 0, 0, 0.12) 0px 2px 1px, rgba(0, 0, 0, 0.2) 0px 1px 3px;
`;
